import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { confirmDialog } from 'primereact/confirmdialog';

import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { deleteSecurityReport } from '../actions';

const SecurityReportRow = props => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const confirmDelete = () =>  {
        confirmDialog({
            message: t('app:really_remove_security_report'),
            icon: 'pi pi-warning-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('common:yes'),
            rejectLabel: t('common:no'),
            accept: () => {
                dispatch(deleteSecurityReport(props.securityReport.id));
            },
            reject: () => {}
        });
    };

    return <div className="sr_row p-shadow-1">
        <Button className="p-button-link" onClick={props.open}>
            <div className="inside_text">
                { props.securityReport.sent ?
                    (props.securityReport.doc_type === 'danger' ?
                        t('app:danger_sent') :
                        t('app:report_sent')) :
                    (props.securityReport.doc_type === 'danger' ?
                        t('app:danger_inprogress') :
                        t('app:report_inprogress'))
                }
                {moment(props.securityReport.date).format('DD/MM/Y HH:mm')}<br/>
                <span className="update">
                    {t('app:last_update')}: {moment(props.securityReport.updated_at).format('DD/MM/YYYY HH:mm')}
                </span>
            </div>
        </Button>
        <Button className="p-button-link" onClick={() => confirmDelete()}>
            <FontAwesomeIcon icon={faTrashAlt} />
        </Button>
    </div> ;
};

export default SecurityReportRow;
